import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/App.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Amplify } from 'aws-amplify';
import amplifyconfiguration from './amplifyconfiguration';

// Configure Amplify with v6 style
Amplify.configure(amplifyconfiguration);

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer position="top-right" autoClose={3000} />
  </React.StrictMode>
);